import { modules, homepage } from './context/index.js';

const PAGE_FILTER = null;
const WDS_PORT = 4000;
const PROXY_URL = 'https://www.powerdistributors.com/';
const isProd = process.env.NODE_ENV !== 'development';
const htmlConfig = {
    ...modules,
    homepage,
};

export { PAGE_FILTER, WDS_PORT, PROXY_URL, isProd, htmlConfig };

// Price Break example: 100005
// LTL Only: 44T977-0009-G1
// Ground Only: 100005 (does not add message on current site (for now))
// disallow e-commerce: 808340
// sell pack: 253, 491588B

// dropdown customize
// https://github.com/harvesthq/chosen
// BS, 1723900SM ---> id = 0
// 5043k(a-k) ----> supersedes from

// Sitefintiy - custom attributes
// https://docs.sitefinity.com/for-developers-use-the-value-of-a-custom-attribute
